import React from 'react';
import pathfinder from '@fiverr-private/pathfinder';
import { I18n } from '@fiverr-private/fiverr_context';
import { Breadcrumbs } from '@fiverr-private/fit';
import { BREADCRUMBS } from './constants';

import './style.scss';

const PageNavigation = () => (
    <Breadcrumbs current={1} className="breadcrumbs">
        {BREADCRUMBS.map(({ titleKey, namedRoute }) => (
            <Breadcrumbs.Crumb key={titleKey}>
                <a href={pathfinder(namedRoute)}>
                    <I18n k={titleKey} />
                </a>
            </Breadcrumbs.Crumb>
        ))}
    </Breadcrumbs>
);

export default PageNavigation;
